import { Select, Space, Badge } from "antd";
import { isEmpty } from "lodash";
import React from "react";

function AllOrderAssign({medicalReps, consultReps,operationsReps,assign, setAssign}) {
  return (
    <div>
      <Select
        allowClear
        onChange={(selectedRowKeys) => setAssign(selectedRowKeys)}
        optionFilterProp="label"
        placeholder="Select a person"
        showSearch
        style={{ width: 240, marginLeft: 10 }}
        value={assign}
      >
        {!isEmpty(medicalReps) &&
          medicalReps?.userRole?.map((rep) => (
            <Option
              label={rep.user.first_name}
              value={rep.user.id}
              key={rep.user.id}
            >
              <Space align="center">
                <div>{rep.user.first_name}</div>
                <Badge
                  count="Medical Rep"
                  style={{ backgroundColor: "#f1f1f1", color: "#313131" }}
                />
              </Space>
            </Option>
          ))}

        {!isEmpty(consultReps) &&
          consultReps?.userRole?.map((rep) => (
            <Option
              label={rep.user.first_name}
              value={rep.user.id}
              key={rep.user.id}
            >
              <Space align="center">
                <div>{rep.user.first_name}</div>
                <Badge
                  count="Consult Rep"
                  style={{ backgroundColor: "#f1f1f1", color: "#313131" }}
                />
              </Space>
            </Option>
          ))}

        {!isEmpty(operationsReps) &&
          operationsReps?.userRole?.map((rep) => (
            <Option
              label={rep.user.first_name}
              value={rep.user.id}
              key={rep.user.id}
            >
              <Space align="center">
                <div>{rep.user.first_name}</div>
                <Badge
                  count="Operations Rep"
                  style={{ backgroundColor: "#f1f1f1", color: "#313131" }}
                />
              </Space>
            </Option>
          ))}
      </Select>
    </div>
   
  );
}

export default AllOrderAssign;
